import {
  ApplicantEntity,
  CandidateEntity,
  CompanyEntity,
  ContactEntity,
  HiringAuthorityEntity,
  JobOrderEntity,
  TabKeys
} from 'UI/constants/entityTypes';

export const ProfileTablesPreferenceKeys = {
  CandidatesActivity: `${CandidateEntity.id}-${TabKeys.ActivityLogs}`,
  CandidatesChangeLogs: `${CandidateEntity.id}-${TabKeys.ChangeLogs}`,
  CandidatesJobOrders: `${CandidateEntity.id}-${TabKeys.JobOrders}`,
  CandidatesMatchJobOrder: `${CandidateEntity.id}-${TabKeys.MatchMaking}-${JobOrderEntity.id}`,
  CandidatesMatchContact: `${CandidateEntity.id}-${TabKeys.MatchMaking}-${ContactEntity.id}`,
  CandidatesNotes: `${CandidateEntity.id}-${TabKeys.Notes}`,
  CandidatesPlacement: `${CandidateEntity.id}-${TabKeys.Placements}`,
  CandidatesReferenceChecks: `${CandidateEntity.id}-${TabKeys.ReferenceCheck}`,
  CandidatesSearchProjects: `${CandidateEntity.id}-${TabKeys.SearchProjects}`,
  CandidatesSendouts: `${CandidateEntity.id}-${TabKeys.Sendouts}`,
  CandidatesTasks: `${CandidateEntity.id}-${TabKeys.Tasks}`,
  CompanyActivity: `${CompanyEntity.id}-${TabKeys.ActivityLogs}`,
  CompanyAssocietedCompanies: `${CompanyEntity.id}-${TabKeys.AssociatedCompanies}`,
  CompanyChangeLogs: `${CompanyEntity.id}-${TabKeys.ChangeLogs}`,
  CompanyEmployees: `${CompanyEntity.id}-${TabKeys.Employees}`,
  CompanyFeeAgreements: `${CompanyEntity.id}-${TabKeys.FeeAgreements}`,
  CompanyHiringAuthorities: `${CompanyEntity.id}-${TabKeys.HiringAuthorities}`,
  CompanyJobOrders: `${CompanyEntity.id}-${TabKeys.JobOrders}`,
  CompanyNotes: `${CompanyEntity.id}-${TabKeys.Notes}`,
  CompanyPlacements: `${CompanyEntity.id}-${TabKeys.Placements}`,
  CompanySales: `${CompanyEntity.id}-${TabKeys.Sales}`,
  CompanySearchProjects: `${CompanyEntity.id}-${TabKeys.SearchProjects}`,
  CompanySendouts: `${CompanyEntity.id}-${TabKeys.Sendouts}`,
  CompanyTasks: `${CompanyEntity.id}-${TabKeys.Tasks}`,
  ContactsActivity: `${ContactEntity.id}-${TabKeys.ActivityLogs}`,
  ContactsChangeLogs: `${ContactEntity.id}-${TabKeys.ChangeLogs}`,
  ContactSearchProjects: `${ContactEntity.id}-${TabKeys.SearchProjects}`,
  ContactsNotes: `${ContactEntity.id}-${TabKeys.Notes}`,
  ContactsTasks: `${ContactEntity.id}-${TabKeys.Tasks}`,
  HiringAuthorityActivity: `${HiringAuthorityEntity.id}-${TabKeys.ActivityLogs}`,
  HiringAuthorityChangeLogs: `${HiringAuthorityEntity.id}-${TabKeys.ChangeLogs}`,
  HiringAuthorityCompanies: `${HiringAuthorityEntity.id}-${TabKeys.Companies}`,
  HiringAuthorityFeeAgreement: `${HiringAuthorityEntity.id}-${TabKeys.FeeAgreements}`,
  HiringAuthorityJobOrders: `${HiringAuthorityEntity.id}-${TabKeys.JobOrders}`,
  HiringAuthorityNotes: `${HiringAuthorityEntity.id}-${TabKeys.Notes}`,
  HiringAuthorityPlacement: `${HiringAuthorityEntity.id}-${TabKeys.Placements}`,
  HiringAuthoritySearchProjects: `${HiringAuthorityEntity.id}-${TabKeys.SearchProjects}`,
  HiringAuthoritySendouts: `${HiringAuthorityEntity.id}-${TabKeys.Sendouts}`,
  HiringAuthorityTasks: `${HiringAuthorityEntity.id}-${TabKeys.Tasks}`,
  JobOrdersActivity: `${JobOrderEntity.id}-${TabKeys.ActivityLogs}`,
  JobOrdersCandidate: `${JobOrderEntity.id}-${TabKeys.Candidates}`,
  JobOrdersChangeLogs: `${JobOrderEntity.id}-${TabKeys.ChangeLogs}`,
  JobOrdersHiringAuthority: `${JobOrderEntity.id}-${TabKeys.HiringAuthorities}`,
  JobOrdersMatchApplicant: `${JobOrderEntity.id}-${TabKeys.MatchMaking}-${ApplicantEntity.id}`,
  JobOrdersMatchCandidate: `${JobOrderEntity.id}-${TabKeys.MatchMaking}-${CandidateEntity.id}`,
  JobOrdersMatchContact: `${JobOrderEntity.id}-${TabKeys.MatchMaking}-${ContactEntity.id}`,
  JobOrdersNotes: `${JobOrderEntity.id}-${TabKeys.Notes}`,
  JobOrdersPlacements: `${JobOrderEntity.id}-${TabKeys.Placements}`,
  JobOrdersSendouts: `${JobOrderEntity.id}-${TabKeys.Sendouts}`,
  JobOrderTasks: `${JobOrderEntity.id}-${TabKeys.Tasks}`
};
